// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import PageLayout from "cxfcomponents/LayoutContainers/PageLayout";

// Soft UI Dashboard PRO React page layout routes
// import pageRoutes from "page.routes";

// Images
import background from "assets/images/sign-in-bg5.png";
import logo from "assets/images/sign-in-logo.png";

function IllustrationLayout({ header="", title="", description="", children, hideContainer = false }) {
  return (
    <PageLayout background="white">
      <SoftBox
        height="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {hideContainer ? (
          <CircularProgress color="info" />
        ) : (
          <SoftBox
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            zIndex={1}
            sx={{
              backgroundColor: "white !important",
              borderRadius: "13px",
              width: "40rem",
              height: "25rem",
              padding: "2rem",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              "@media (max-width: 768px)": {
                width: "100%",
                height: "100vh",
                borderRadius: "0",
                padding: "1rem",
              },
            }}
          >
            <SoftBox mt={5} mb={3} display="flex" justifyContent="center">
              <img src={logo} alt="CXF logo" style={{ height: "53px" }} />
            </SoftBox>
            <SoftBox px={3} textAlign="center">
              {!header ? (
                <>
                  <SoftBox mb={4}>
                    <SoftTypography variant="h4" fontWeight="bold" className="signInTitle">
                      {title}
                    </SoftTypography>
                  </SoftBox>
                  <SoftTypography variant="body2" fontWeight="regular" color="text">
                    {description}
                  </SoftTypography>
                </>
              ) : (
                header
              )}
            </SoftBox>
          <SoftBox
            p={6}
            mt={3}
            width="75%"
          >
              {children}
            </SoftBox>
          </SoftBox>
        )}
      </SoftBox>
    </PageLayout>
  );
}

// Typechecking props for the IllustrationLayout
IllustrationLayout.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  hideContainer: PropTypes.bool,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default IllustrationLayout;
